module.exports = __webpack_public_path__ + "img/checked.d0d4e75e.png";